<template>
  <div :id="'doc-universe-' + _uid" class="docuniverse" :layout="responsive">
    <div id="svgDiv" class="doc-univ">
      <svg height="100%" width="100%"></svg>
      <div id="hoverDiv"></div>
      <div id="load-div-docuni" class="loading-visualization">
        <div class="d-flex justify-content-center">
          <b-spinner
            style="width: 5rem; height: 5rem; margin-top:20%"
            variant="secondary-orange"
            label="Large Spinner"
            type="grow"
          ></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import { EventBus } from "@/eventBus";
import store from "../../../store/store";
import DocUniverse from "./DocUniverseClass";

export default {
  name: "DocUniverseView",
  props: {
    showControls: Boolean,
    showTitle: Boolean,
    responsive: Boolean
  },
  data() {
    return {
      loadingStatus: true,
      visualization: null,
      showContour: true,
      showFields: true,
      showFieldsNames: true,
      showArrows: true,
      showThemes: false,
      showLabels: false,
      showDocuments: false,
      showNonMatchingDocuments: true,
      showOverlappingDocuments: true,
      showRings: false,
      showRingsNoMatch: false,
      startYear: 0,
      recentYear: 0,
      stopYear: 0,
      isolateFields: false,
      minimumConnections: 2,
      cutoff: 0.2,
      associations: [{ layers: [["TTC", 1]] }],
      ring: []
    };
  },
  computed: {
    ...mapState({
      documentsPerYear: state => state.document.documentsPerYear,
      filterFocused: state => state.filter.filterFocused,
      filterFocusedType: state => state.filter.filterFocusedType
    }),
    ringStringified: {
      get() {
        return JSON.stringify(this.ring);
      },
      set(val) {
        this.query = JSON.parse(val);
      }
    }
  },
  watch: {
    filterFocused() {
      //if (this.filterFocusedType !== "focus") {
        this.visualization.init(true);
      //}
    },
    showContour(value) {
      this.visualization.setShowContour(value);
      this.visualization.draw();
    },
    showFields(value) {
      this.visualization.setShowFields(value);
      this.visualization.draw();
    },
    showFieldsNames(value) {
      this.visualization.setShowFieldsNames(value);
      this.visualization.draw();
    },
    showArrows(value) {
      this.visualization.setShowArrows(value);
      this.visualization.draw();
    },
    showThemes(value) {
      this.visualization.setShowThemes(value);
      this.visualization.draw();
    },
    showLabels(value) {
      this.visualization.setShowLabels(value);
      this.visualization.draw();
    },
    showDocuments(value) {
      this.visualization.setShowDocuments(value);
      this.visualization.draw();
    },
    showNonMatchingDocuments(value) {
      this.visualization.setShowNonMatchingDocuments(value);
      this.visualization.draw();
    },
    showOverlappingDocuments(value) {
      this.visualization.setShowOverlappingDocuments(value);
      this.visualization.draw();
    },
    showRings(value) {
      this.visualization.setShowRings(value);
      this.visualization.draw();
    },
    showRingsNoMatch(value) {
      this.visualization.setShowRingsNoMatch(value);
      this.visualization.draw();
    },
    isolateFields(value) {
      this.visualization.setIsolateFields(value);
      this.visualization.draw();
    }
  },
  mounted() {
    if (!this._uid) {
      console.error("Please set ID property");
      return false;
    }
    if (this.documentsPerYear.length > 0) {
      this.startYear = parseInt(_.minBy(this.documentsPerYear, "year").year);
      this.stopYear = parseInt(_.maxBy(this.documentsPerYear, "year").year);
      this.recentYear = Math.max(this.startYear, this.stopYear - 2);
    }
    // Remove "old" events from destroyed item
    EventBus.$off([
      "showContourChanged",
      "showFieldsChanged",
      "showFieldsNamesChanged",
      "showArrowsChanged",
      "showThemesChanged",
      "showLabelsChanged",
      "showDocumentsChanged",
      "showNonMatchingDocumentsChanged",
      "showOverlappingDocumentsChanged",
      "showRingsChanged",
      "showRingsNoMatchChanged",
      "isolateFieldsChanged",
      "setMinimumConnections",
      "setStartYear",
      "setRecentYear",
      "setStopYear",
      "setCutoff",
      "setAssociations",
      "setRing",
      "setTableTop",
      "resetData"
    ]);
    EventBus.$on("showContourChanged", value => {
      this.showContour = value;
    });
    EventBus.$on("showFieldsChanged", value => {
      this.showFields = value;
    });
    EventBus.$on("showFieldsNamesChanged", value => {
      this.showFieldsNames = value;
    });
    EventBus.$on("showArrowsChanged", value => {
      this.showArrows = value;
    });
    EventBus.$on("showThemesChanged", value => {
      this.showThemes = value;
    });
    EventBus.$on("showLabelsChanged", value => {
      this.showLabels = value;
    });
    EventBus.$on("showDocumentsChanged", value => {
      this.showDocuments = value;
    });
    EventBus.$on("showNonMatchingDocumentsChanged", value => {
      this.showNonMatchingDocuments = value;
    });
    EventBus.$on("showOverlappingDocumentsChanged", value => {
      this.showOverlappingDocuments = value;
    });
    EventBus.$on("showRingsChanged", value => {
      this.showRings = value;
    });
    EventBus.$on("showRingsNoMatchChanged", value => {
      this.showRingsNoMatch = value;
    });
    EventBus.$on("isolateFieldsChanged", value => {
      this.isolateFields = value;
    });
    EventBus.$on("setMinimumConnections", e => {
      this.setMinimumConnections(e);
    });
    EventBus.$on("setStartYear", e => {
      this.setStartYear(e);
    });
    EventBus.$on("setRecentYear", e => {
      this.setRecentYear(e);
    });
    EventBus.$on("setStopYear", e => {
      this.setStopYear(e);
    });
    EventBus.$on("setCutoff", e => {
      this.setCutoff(e);
    });
    EventBus.$on("setAssociations", e => {
      this.setAssociations(e);
    });
    EventBus.$on("setRing", e => {
      this.setRing(e);
    });
    EventBus.$on("setTableTop", e => {
      this.setTableTop(e);
    });
    EventBus.$on("resetData", () => {
      this.resetData();
    });

    this.visualization = new DocUniverse("#doc-universe-" + this._uid + " svg");
    this.visualization.setAssociations(this.associations);
    this.visualization.setCutoff(parseFloat(this.cutoff));
    this.visualization.setMinimumConnections(this.minimumConnections);
    //this.visualization.setRing(this.ring);
    this.visualization.setStartYear(this.startYear);
    this.visualization.setRecentYear(this.recentYear);
    this.visualization.setStopYear(this.stopYear);
    this.visualization.setShowContour(this.showContour);
    this.visualization.setShowFields(this.showFields);
    this.visualization.setShowFieldsNames(this.showFieldsNames);
    this.visualization.setShowArrows(this.showArrows);
    this.visualization.setShowThemes(this.showThemes);
    this.visualization.setShowLabels(this.showLabels);
    this.visualization.setShowDocuments(this.showDocuments);
    this.visualization.setShowNonMatchingDocuments(
      this.showNonMatchingDocuments
    );
    this.visualization.setShowOverlappingDocuments(
      this.showOverlappingDocuments
    );
    this.visualization.setShowRings(this.showRings);
    this.visualization.setShowRingsNoMatch(this.showRingsNoMatch);
    if (this.visualization && this.filterFocused) {
      this.visualization.init(true);
    } else {
      this.visualization.init(false);
    }
  },
  destroyed() {
    this.visualization.destroy();
  },
  methods: {
    setMinimumConnections(e) {
      this.visualization.setMinimumConnections(e.target.value);
      this.visualization.init(true);
    },
    setStartYear(e) {
      this.visualization.setStartYear(e);
      this.visualization.init(true);
    },
    setRecentYear(e) {
      this.visualization.setRecentYear(e);
      this.visualization.init(true);
    },
    setStopYear(e) {
      this.visualization.setStopYear(e);
      this.visualization.init(true);
    },
    setCutoff(e) {
      this.visualization.setCutoff(e.target.value);
      this.visualization.init(true);
    },
    setAssociations(e) {
      this.visualization.setAssociations(JSON.parse(e.target.value));
      this.visualization.init(true);
    },
    setRing(e) {
      store.dispatch("saveFieldRings", e);
      this.visualization.init(true, true, false);
    },
    setTableTop(e) {
      store.dispatch("saveFieldTableTop", e);
      this.visualization.init(true, false, true);
    },
    resetData() {
      this.visualization.init(true);
    }
  }
};
</script>
